import React, { useEffect, useState } from "react";
import "./Marketing.css";

import profileimg from "../../assets/profile-img.png";
import myadvertisements from "../../assets/myadvertisements.png";
import marketinglogo from "../../assets/marketing-logo.png";
import marketingimg from "../../assets/m-img.png";
import addadvertisements from "../../assets/addadvertisements.png";
import logoutimg from "../../assets/logout-img.png";
import accountimg from "../../assets/account-img.png";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { BaseUrl } from "../../App";
import BuyerServicesUrl from "../../BuyerServicesUrl";
// import { toast } from "react-toastify";
import { createPortal } from "react-dom";

export default function Marketing() {
  const token = localStorage.getItem("token");

  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);
  const [marketingStatus, setMarketingStatus] = useState(null);

  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const navigate = useNavigate();

const handleLogout = () => {
  localStorage.removeItem("token");
  // toast.success("تم تسجيل الخروج 👋");
  navigate("/login");
};
  // مهم عشان نفرّق بين:
  // "الـ API راجع pending" و "اليوزر ضغط فعلاً"
  const [hasClicked, setHasClicked] = useState(
    localStorage.getItem("marketing_clicked") === "true"
  );

  /* ===== GET MARKETING DATA ===== */
  useEffect(() => {
    axios
      .get(BaseUrl + BuyerServicesUrl.GetMarketingData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setMarketingStatus(res.data.data?.status || null);
      })
      .catch(() => {
        setMarketingStatus(null);
      })
      .finally(() => setLoading(false));
  }, [token]);

  /* ===== SEND MARKETING REQUEST ===== */
  const handleMarketingRequest = () => {
    setSending(true);

    axios
      .get(BaseUrl + BuyerServicesUrl.SendMarketingRequest, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(() => {
        setMarketingStatus("pending");
        setHasClicked(true);
        localStorage.setItem("marketing_clicked", "true");
      })
      .catch((err) => {
        console.log("SEND MARKETING ERROR", err);
      })
      .finally(() => setSending(false));
  };

  return (
    <>
{showLogoutModal &&
  createPortal(
    <>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "rgba(0,0,0,0.5)",
          zIndex: 9999,
        }}
        onClick={() => setShowLogoutModal(false)}
      />

      <div className="m-auto "
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          background: "#fff",
          padding: "28px",
          borderRadius: "10px",
          width: "90%",
          maxWidth: "400px",
          zIndex: 10000,
          textAlign: "right",
        }}
        dir="rtl"
      >
        {/* <h5 className="mb-3 ">تأكيد تسجيل الخروج</h5> */}
        <h5 className="pt-4 pb-3 fw-bold text-center logout-modalmessage">هل تريد تسجيل الخروج؟</h5>
  {/* <hr className="m-auto"/> */}
        <div className="d-flex justify-content-center gap-2 mt-3 mb-3">
             <button
            className="btn btn-danger px-5 "
            onClick={handleLogout}
          >
            نعم
          </button>
          <button
            className="btn btn-secondary  px-5"
            onClick={() => setShowLogoutModal(false)}
          >
            لا
          </button>
        </div>
      </div>
    </>,
    document.body
  )}
    <div className="mmarketing-page mt-5 mb-5">
      <div className="container mt-5 mb-5 pb-5">
        <div className="row mb-5 pb-5">

          {/* ===== SIDEBAR ===== */}
          <div className="m-marketing-sidebar mt-3 mb-5 col-md-6">
            <Link to="/profileaccount" className="side-btn white mt-5">
              <img src={profileimg} alt="" />
              <span className="px-2">حسابي الشخصي</span>
            </Link>

            <Link to="/marketing" className="side-btn active d-flex justify-content-start">
              <img src={marketingimg} alt="" />
              <span className="px-2">التسويق</span>
            </Link>
                        {/* <Link to="/bankaccount" className=" side-btn2 text-dark text-decoration-none" style={{width:"70px"}}>
                            <img className='ps-3' src={accountimg} alt="Bank" style={{    width: "22%",
    marginRight: "5%"}} />
                                        الحساب البنكي
                          </Link> */}
                            <Link to="/bankaccount" className=" side-btn2 text-dark text-decoration-none" style={{width:"98%"}}>
                                                               <img className='ps-3' src={accountimg} alt="Bank" style={{ width: "14%",
                                       marginRight: "2%"}} />
                                                                           الحساب البنكي
                                                             </Link>

            <Link to="/myaddvertisements" className="side-btn white">
              <img src={myadvertisements} alt="" />
              <span className="px-2">إعلاناتي</span>
            </Link>

            <Link to="/addadvertisement" className="side-btn white">
              <img src={addadvertisements} alt="" />
              <span className="px-2">إضافة إعلان</span>
            </Link>

            {/* <Link
              to="/accounttype"
              className="side-btn logout"
              onClick={() => {
                localStorage.removeItem("token"); 
              }}
            >
              <img src={logoutimg} alt="" />
              <span className="px-2">تسجيل الخروج</span>
            </Link> */}
            <button
  type="button"
  className="side-btn logout border-0"
  onClick={() => setShowLogoutModal(true)}
>
  <img src={logoutimg} alt="" />
  <span className="px-2">تسجيل الخروج</span>
</button>
          </div>

          {/* ===== MAIN CONTENT ===== */}
          <div className="marketing-content col-md-6">
            <img
              src={marketinglogo}
              alt="طوق النجاة"
              className="marketing-logo"
            />

        {loading ? (
  <div className="favorites-loader text-center py-5">
    <div className="loader-circle mb-3"></div>
    <p className="fw-bold">جاري تحميل التسويق...</p>
  </div>
)
 : marketingStatus === "pending" && hasClicked ? (
              <>
                <div className="pending-box">
                  ⏳ طلبك قيد المراجعة
                </div>

                <p className="pending-desc">
                  تم إرسال طلبك بنجاح وهو الآن قيد المراجعة،
                  <br />
                  سيتم الرد في أسرع وقت.
                </p>
              </>
            ) : (
              <>
                <p className="marketing-text">
                  انضم لبرنامج التسويق بالعمولة وابدأ بكسب عمولات علي
                  <br />
                  كل مستخدم يستخدم كودك الخاص كلما زاد عدد
                  <br />
                  المستخدمين. زادت أرباحك!
                </p>

                <button
                  className="marketing-main-btn"
                  onClick={handleMarketingRequest}
                  disabled={sending}
                >
                  {sending ? "جاري الإرسال..." : "طلب تسويق"}
                </button>
              </>
            )}
          </div>

        </div>
      </div>
    </div>
    </>
  );
}
